export default __webpack_public_path__ + "static/media/2_RIVER_WHITE_120X278_265.5e8246ca.jpg";